import React from 'react'

import Navbar from './navbar'
import Footer from './footer'
import {Container} from 'react-bootstrap'

const MainLayout = ({children}) => {
  return (
    <Container fluid>
      <Navbar />
      <Container style={{marginTop: 5}} fluid>
        {children}
      </Container>
      <Footer />
    </Container>
  )
}

export default MainLayout
